import { connectRefinementList } from 'react-instantsearch-dom';

import FacetList from './FacetList';

const ConnectedCheckBoxList = connectRefinementList(FacetList);

export default ConnectedCheckBoxList;



// WEBPACK FOOTER //
// ./src/components/Algolia/ConnectedList.js